import { Box, Container, Divider } from "@mui/material";
import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import { useAnimation } from "../contexts/AnimationContext";
import Stay from "../components/Accommodation";
import Travel from "../components/Travel";

function TravelAndStay() {
  const dividerRef = useRef(null);
  const dividerInView = useInView(dividerRef, { once: true, margin: "0px" });
  const { animationStarted } = useAnimation();
  return (
    <>
      <Box
        id="travel"
        component="section"
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          pt: 6,
          pb: 2,
          px: 2,
          scrollMarginTop: "20px",
        }}
      >
        <Stay />
        <Travel />
      </Box>
      <Container maxWidth="md" sx={{ mt: 6, mb: -2 }}>
        <Divider
          component={motion.hr}
          ref={dividerRef}
          initial={{ opacity: 0, scaleX: 0 }}
          animate={
            dividerInView && animationStarted
              ? { opacity: 0.3, scaleX: 1 }
              : { opacity: 0, scaleX: 0 }
          }
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          sx={{
            my: 2,
            mx: { xs: 4, sm: 6, md: 8 },
            borderColor: "#8b7355",
          }}
        />
      </Container>
    </>
  );
}

export default TravelAndStay;
